import { useContext, useState } from 'react';
import { ContextProvider, Context_Subscription, Context_Compliance_Scores } from '../../Data/ContextProvider';


//completionPercent: 0/<20
//complianceScore: <70/<90/>=90
//implementation_Difficulty: 0/<=50/<=75/>75


export default function ScoreComputations() {

    const [Compliance_Scores_Data_GVars, Update_Compliance_Scores_Data_GVars] = useContext(Context_Compliance_Scores);

    const [L2_Recurring_GVars, Update_L2_Recurring_GVars] = useContext(Context_L2_Recurring);

    var completion_Percent = 0;
    var compliance_Score = 0;
    var implementation_Difficulty = 0;
    var compliance_Areas = L2_Recurring_GVars.Checking_Comp_With;


    if (L2_Recurring_GVars.S2_Payment_Interval.Interval_Regular == true) {
        completion_Percent += 10;
        compliance_Score += 0;
        implementation_Difficulty += 0;
    }
    else if (L2_Recurring_GVars.S2_Payment_Interval.Interval_Variable == true) {
        completion_Percent += 10;
        compliance_Score += 0;
        implementation_Difficulty += 51;
    }

//=======
    if (L2_Recurring_GVars.S3_Payment_Frequency.Subscription_Annually_Checked || L2_Recurring_GVars.S3_Payment_Frequency.Subscription_Quarterly_Checked || L2_Recurring_GVars.S3_Payment_Frequency.Subscription_Monthly_Checked || L2_Recurring_GVars.S3_Payment_Frequency.Subscription_Other_Fixed) {
        [completion_Percent, compliance_Score, implementation_Difficulty] = [completion_Percent + 10, compliance_Score, implementation_Difficulty];
    }

    else if (L2_Recurring_GVars.S3_Payment_Frequency.Subscription_Variable) {
        [completion_Percent, compliance_Score, implementation_Difficulty] = [20, 0, 51];
    }
//=======
    if (L2_Recurring_GVars.S4_Payment_Instrument.CreditCard || L2_Recurring_GVars.S4_Payment_Instrument.Debit || L2_Recurring_GVars.S4_Payment_Instrument.ACH) {
                [completion_Percent, compliance_Score, implementation_Difficulty] = [30, 95, 70];
    }
    else if (L2_Recurring_GVars.S4_Payment_Instrument.Crypto){
        [completion_Percent, compliance_Score, implementation_Difficulty] = [30, 0, 91];
    }
//=======
    if (L2_Recurring_GVars.S5_Consumer_or_Business.Consumer_Under_13) {
        completion_Percent += 10;
        implementation_Difficulty += 5;
        compliance_Score = 0;
    }

    else if (L2_Recurring_GVars.S5_Consumer_or_Business.Consumer_13_to_18) {
        completion_Percent += 10;
        compliance_Score = 0;
    }
    else if (L2_Recurring_GVars.S5_Consumer_or_Business.Consumer_Over_18) {
        [completion_Percent, compliance_Score, implementation_Difficulty] = [45, 60, 75];
    }

    else if (L2_Recurring_GVars.S5_Consumer_or_Business.Business || L2_Recurring_GVars.S5_Consumer_or_Business.Business_for_Consumer) {
        [completion_Percent, compliance_Score, implementation_Difficulty] = [45, 60, 75];
    }

      

//    [Compliance_Scores_Data_GVars.completionPercent, Compliance_Scores_Data_GVars.complianceScore, Compliance_Scores_Data_GVars.implementation_Difficulty] = [completion_Percent, compliance_Score, implementation_Difficulty];
    
    // Update_Compliance_Scores_Data_GVars(Compliance_Scores_Data_GVars => ({ ...Compliance_Scores_Data_GVars, complianceScore: compliance_Score }));

    Compliance_Scores_Data_GVars.complianceScore = compliance_Score;
    Compliance_Scores_Data_GVars.implementationDifficulty = implementation_Difficulty;
    Compliance_Scores_Data_GVars.completionPercent = completion_Percent;
    Compliance_Scores_Data_GVars.Checking_Comp_With = compliance_Areas;

return(null)

}